<template>
  <div class="order-page pl-4">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text" v-html="message.success"></span>
      <template v-slot:action="{ attrs }">
        <v-btn icon color="white" class="body-1 font-weight-bold text-capitalize" v-bind="attrs" @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.imei" @keydown.esc="dialog.imei = false" :fullscreen="dialog.fullscreen" width="500" persistent scrollable>
      <v-card :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'">
        <v-card-title class="d-flex align-center pb-4 text-right popup-header fs-20 font-weight-bold">
          Reset Imei
          <v-spacer />
          <v-icon @click="dialog.imei = false; dialog.fullscreen = false;" class="cursor-pointer" size="18" color="#000000">mdi-close</v-icon>
        </v-card-title>
        <v-divider class="mb-2" style="border-top: 2px dashed #e0e0e0;" />
        <v-card-text class="body-1 font-weight-light my-0 py-3">
          Apakah anda yakin ingin mereset Imei dari pegawai ini?
          <div v-if="message.error" class="text-center mt-2">
            <div class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
              <span class="ml-1">{{ message.error }}</span>
            </div>
          </div>
        </v-card-text>
        <v-divider class="mt-2" style="border-top: 2px dashed #e0e0e0;" />
        <v-card-actions class="pt-4 pb-4">
          <v-spacer />
          <v-btn @click="save()" :loading="process.delete" :disabled="process.delete" elevation="0" width="120" color="#00ADB5" style="border-radius: 8px;" class="fs-14 white--text font-weight-bold text-capitalize px-3">Ya, reset</v-btn>
          <v-btn width="120" @click="dialog.imei = false; dialog.fullscreen = false;" :disabled="process.delete" outlined style="border-radius: 8px;" class="fs-14 font-weight-bold text-capitalize red--text">Batal</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="animated-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
    </div>

    <div class="page-header">
      <div class="header-content px-2">
        <div class="d-flex">
          <h1>Detail Staff</h1>
          <div class="header-badge ml-2">
            <v-icon size="14" color="white">mdi-account-details</v-icon>
            <span>Staff</span>
          </div>
        </div>
        <p>Informasi lengkap data pribadi dan data pegawai</p>
      </div>
    </div>

    <div class="main-card detail-card">
      <v-card-text v-if="process.form" class="detail-loading">
        <div class="text-center">
          <div class="mb-2 title">Mohon Tunggu...</div>
          <v-progress-circular indeterminate color="#00ADB5"></v-progress-circular>
        </div>
      </v-card-text>

      <template v-if="!process.form && Object.keys(detail).length > 0">
        <!-- Hero: Nama + Badge -->
        <div class="detail-hero">
          <div class="detail-hero-avatar">
            <v-img v-if="detail.image_url" :src="detail.image_url" contain aspect-ratio="1" class="rounded"></v-img>
            <div v-else class="detail-hero-avatar-placeholder">
              <v-icon size="48" color="#9ca3af">mdi-account</v-icon>
            </div>
          </div>
          <div class="detail-hero-info">
            <h2 class="detail-hero-name">{{ detail.name }}</h2>
            <div class="detail-hero-meta">
              <span class="detail-chip">{{ detail.category_user_title }}</span>
              <span class="detail-chip">{{ detail.branch_name }}</span>
              <span v-if="detail.code" class="detail-chip detail-chip-outline">Kode: {{ detail.code }}</span>
            </div>
          </div>
        </div>

        <div class="detail-body">
          <!-- Data Pribadi -->
          <div class="detail-section mt-1">
            <!-- <div class="d-flex align-center detail-section-title"> -->
              <!-- <div class="step-icon mint">
                <v-icon color="#00897B" size="22">mdi-account-outline</v-icon>
              </div> -->
            <h3 class="detail-section-title">Data Pribadi</h3>
            <!-- </div> -->
            <div class="detail-rows">
              <div class="detail-row">
                <span class="detail-label">NIK</span>
                <span class="detail-value">{{ detail.nik }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Email</span>
                <span class="detail-value">{{ detail.email || '-' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Mobilephone</span>
                <span class="detail-value">{{ detail.mobilephone || '-' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Jenis Kelamin</span>
                <span class="detail-value">{{ detail.gender || '-' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Alamat</span>
                <span class="detail-value">{{ detail.address || '-' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">No. Rekening</span>
                <span class="detail-value">{{ detail.bank_name }} – {{ detail.rek_number || '-' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Nama Rekening</span>
                <span class="detail-value">{{ detail.rek_name || '-' }}</span>
              </div>
              <template v-if="detail.category_user_title === 'Driver'">
                <div class="detail-row">
                  <span class="detail-label">Imei</span>
                  <span class="detail-value">{{ detail.imei || '-' }}</span>
                </div>
                <div class="detail-row detail-row-action">
                  <span class="detail-label"></span>
                  <v-btn class="text-capitalize white--text" color="#00ADB5" elevation="0" small rounded @click="dialog.imei = true; form.imei = ''; message.error = '';">
                    <v-icon left size="16">mdi-refresh</v-icon>
                    Reset Imei
                  </v-btn>
                </div>
              </template>
            </div>
          </div>

          <!-- Data Pegawai -->
          <div class="detail-section">
            <h3 class="detail-section-title">Data Pegawai</h3>
            <div class="detail-rows">
              <div class="detail-row">
                <span class="detail-label">Tanggal Bergabung</span>
                <span class="detail-value">{{ detail.join_date | dateFull }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Deskripsi</span>
                <span class="detail-value">{{ detail.desc || '-' }}</span>
              </div>
            </div>
          </div>

          <!-- Dokumen -->
          <div class="detail-section">
            <h3 class="detail-section-title">Dokumen</h3>
            <div class="detail-docs">
              <div class="detail-doc-item">
                <div class="detail-doc-label">Foto Pegawai</div>
                <div class="detail-doc-value">
                  <div class="detail-img-box">
                    <v-img :src="detail.image_url" contain aspect-ratio="1"></v-img>
                  </div>
                </div>
              </div>
              <div class="detail-doc-item">
                <div class="detail-doc-label">Tanda Tangan</div>
                <div class="detail-doc-value">
                  <div class="detail-img-box detail-img-box-ttd">
                    <v-img :src="detail.ttd" contain></v-img>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="message.error" class="detail-alert">
            <v-alert type="error" dense dismissible>{{ message.error }}</v-alert>
          </div>

          <div class="detail-actions">
            <v-btn to="/user/staff" :disabled="process.form" color="#00ADB5" class="white--text px-6" rounded elevation="0">
              <v-icon left>mdi-arrow-left</v-icon>
              Kembali
            </v-btn>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,

          dialog: {
            snackbar: false,
            imei: false,
            fullscreen: false
          },

          detail: {},
  
          form: {
            id: '',
            par_id: '0',
            category_user_id: '',
            branch_id: '',
            code: '',
            name: '',
            mobilephone: '',
            address: '',
            gender: '',
            email: '',
            nik: '',
            rek_number: '',
            rek_name: '',
            join_date: '',
            bank_name: '',
            image_url: '',
            desc: '',
            ttd: '',
            imei: ''
          },
          category: [],
          branch: [],
  
          mobilephone: {
            name: '',
            id: ''
          },
  
          upload: {
            ttd: null,
            image_url: null
          },
  
          process: {
            form: false,
  
            ttd: false,
  
            image_url: false,
            delete: false
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.ttd': {
          handler: function () {
            if (this.upload.ttd) {
              this.process.ttd = this.upload.ttd.process
  
              if (!this.process.ttd) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.ttd = this.upload.ttd.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
  
        'upload.image_url': {
          handler: function () {
            if (this.upload.image_url) {
              this.process.image_url = this.upload.image_url.process
  
              if (!this.process.image_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        }
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail () {
          this.process.form = true
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/user/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.detail = res.results.data
            }
            this.process.form = false
          })
        },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
        async save () {
          this.message.error = ''

          const isValid = true

          if (isValid) {
            this.process.delete = true

            let url = 'admin/user/reset_imei'

            // SAVE TO REST API
            await post(url, {
              data: {
                id: this.detail.id
              }
            })
            .then(response => {
              let res = response.data
              
              this.process.delete = false

              if (res.status === 200) {
                this.dialog.imei = false
                
                this.fetchDetail()
                this.dialog.snackbar = true
                this.message.success = res.message

                this.dialog.fullscreen = false
                
              } else {
                this.message.error = res.message
              }
            })

          } else {
            this.error = 'Imei tidak boleh kosong'
          }
        },
      }
    }
  </script>

<style scoped>
.order-page {
  position: relative;
  padding: 18px;
  padding-top: 36px;
  min-height: 100%;
  background: linear-gradient(180deg, #fcfcfc 0%, #f8fafa 100%);
}

.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.6;
  animation: float 20s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  top: -100px;
  right: -50px;
  filter: blur(60px);
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
  bottom: 100px;
  left: -50px;
  filter: blur(50px);
  animation-delay: -5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  top: 50%;
  right: 20%;
  filter: blur(40px);
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(20px) rotate(-5deg); }
}

.page-header {
  position: relative;
  z-index: 1;
  margin-bottom: 28px;
}

.header-content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.header-content p {
  font-size: 14px;
  color: #393E46;
  margin: 0;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  border-radius: 20px;
}

.header-badge span {
  font-size: 11px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.main-card {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
  border: 1px solid rgba(238, 238, 238, 0.6);
  overflow: hidden;
}

.detail-loading {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-card {
  padding: 0;
}

/* Hero: nama + avatar + badge */
.detail-hero {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px 24px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
}

.detail-hero-avatar {
  width: 72px;
  height: 72px;
  min-width: 72px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f3f4;
}

.detail-hero-avatar .v-img {
  width: 100%;
  height: 100%;
}

.detail-hero-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-hero-info {
  flex: 1;
  min-width: 0;
}

.detail-hero-name {
  font-size: 20px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 8px;
  line-height: 1.3;
}

.detail-hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.detail-chip {
  font-size: 12px;
  font-weight: 600;
  color: white;
  background: #00ADB5;
  padding: 4px 10px;
  border-radius: 6px;
}

.detail-chip-outline {
  background: transparent;
  color: #393E46;
  border: 1px solid #e8eaed;
}

/* Body: section + rows */
.detail-body {
  padding: 0 24px 24px;
}

.detail-section {
  padding-top: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.detail-section:last-of-type {
  border-bottom: none;
}

.detail-section-title {
  font-size: 13px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.detail-rows {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #f8f9fa;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-row-action {
  align-items: center;
}

.detail-label {
  flex: 0 0 140px;
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.detail-value {
  flex: 1;
  font-size: 14px;
  color: #222831;
  font-weight: 500;
  line-height: 1.5;
  word-break: break-word;
}

/* Dokumen: foto + TTD */
.detail-docs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.detail-doc-item {
  margin-top: 4px;
}

.detail-doc-label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  margin-bottom: 10px;
}

.detail-doc-value {
  margin: 0;
}

.detail-img-box {
  border: 1px solid #e8eaed;
  border-radius: 10px;
  overflow: hidden;
  width: 160px;
  aspect-ratio: 1;
  background: #fafbfc;
}

.detail-img-box .v-img {
  width: 100%;
  height: 100%;
}

.detail-img-box-ttd {
  width: 220px;
  aspect-ratio: 250/150;
}

.detail-alert {
  margin-top: 20px;
}

.detail-actions {
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
  text-align: right;
}

@media (max-width: 600px) {
  .detail-hero {
    flex-direction: column;
    text-align: center;
  }
  .detail-hero-meta {
    justify-content: center;
  }
  .detail-row {
    flex-direction: column;
    gap: 4px;
    padding: 12px 0;
  }
  .detail-label {
    flex: none;
  }
  .detail-docs {
    grid-template-columns: 1fr;
  }
  .detail-img-box-ttd {
    width: 100%;
    max-width: 220px;
  }
}

.step-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-icon.mint {
  background: linear-gradient(135deg, #E0F2F1 0%, #E0F2F1 100%);
  box-shadow: 0 8px 20px rgba(168, 230, 207, 0.3);
}
</style>